var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_67_3200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4461 19.6579L22.3561 17.4779C21.9211 16.6089 21.0891 16.0009 20.1281 15.8539L15.5621 15.1509C14.4871 15.6889 13.2801 15.9989 11.9981 15.9989C10.7161 15.9989 9.50911 15.6889 8.43411 15.1509L3.86811 15.8539C2.90711 16.0009 2.07511 16.6089 1.64011 17.4779L0.550106 19.6579C0.0811062 20.5949 0.131106 21.6859 0.681106 22.5769C1.23211 23.4679 2.18611 23.9999 3.23411 23.9999H20.7631C21.8111 23.9999 22.7651 23.4679 23.3161 22.5769C23.8661 21.6859 23.9151 20.5949 23.4461 19.6579Z",
    fill: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0C8.691 0 6 2.691 6 6V8C6 11.309 8.691 14 12 14C15.309 14 18 11.309 18 8V6C18 2.691 15.309 0 12 0Z",
    fill: "#2C2C2C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_67_3200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.19c40eb83b6f19faa21dbf77c3e07061.svg";
export { ForwardRef as ReactComponent };